import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './ModelFolders.css';

export default function ModelDeleteDialog({ models, target, name, description, onClose, onDeleted }) {
    const [confirmation, setConfirmation] = useState('');
    const [revision] = useState(models.data?.revision);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const pending = useRef(false);
    const ref = useRef(null);
    useEffect(() => {
        const previous = document.activeElement;
        ref.current.showModal();
        return () => { if (previous?.isConnected) previous.focus(); };
    }, []);
    return createPortal(
        <dialog ref={ref} className="model-folder-dialog model-delete-dialog" aria-label="Eliminació permanent"
            onCancel={e => { e.preventDefault(); if (!busy) onClose(); }}>
            <form className="model-folder-dialog-form" onSubmit={async e => {
                e.preventDefault();
                if (!name || confirmation !== name || pending.current || models.busy) return;
                pending.current = true;
                setBusy(true);
                setError('');
                try {
                    await models.mutate('delete-permanently', { ...target, confirmation, revision });
                    onDeleted?.();
                    onClose();
                } catch (err) {
                    setError(err.message);
                } finally {
                    pending.current = false;
                    setBusy(false);
                }
            }}>
                <h3>Elimina definitivament «{name}»</h3>
                <p className="model-delete-warning">{description || 'S’eliminarà aquesta pinya model.'} Aquesta acció no es pot desfer i el contingut no es podrà recuperar des d’Arxivats.</p>
                <label className="model-folder-dialog-field">Escriu «{name}» per confirmar
                    <input autoFocus className="model-folder-dialog-control" type="text" autoComplete="off" autoCapitalize="none" spellCheck={false}
                        value={confirmation} onChange={e => setConfirmation(e.target.value)} disabled={busy} />
                </label>
                {error && <p role="alert">{error}</p>}
                <div className="model-folder-dialog-actions">
                    <button type="button" onClick={onClose} disabled={busy}>Cancel·la</button>
                    <button type="submit" className="model-folder-danger" disabled={busy || models.busy || !name || confirmation !== name}>
                        {busy ? 'Eliminant…' : 'Elimina definitivament'}
                    </button>
                </div>
            </form>
        </dialog>, document.body
    );
}
